import _ from 'lodash'

/**
 * Adds an href property to each principal based on their groupType.
 * @param principals The array of principals (owner/updater/user/group)
 * @returns The modified principals with href property.
 */
function addHrefToPrincipals(principals) {
	_.each(principals, (principal) => {
		principal.href = principal.groupType ? `/admin/groups/${principal.id}`
			: `/admin/users/${principal.id}`
	})
	return principals
}

export default addHrefToPrincipals
addHrefToPrincipals.__filename__ = 'components/add-href-to-principals.js'
